import {getFromLocalStorage, getFromLocalStorageOrDefault, storeToLocalStorage} from '../../utils/utils';

const RANDOM_USER_ID_KEY = 'userId';
const SEARCH_CONTAINER = 'containerName';
const SHOW_DETAILS = 'showDetails';
const SHOW_VALIDATION = 'showValidation';
const SHOW_FIELD_SPECIFIC_SEARCH = 'showFieldSpecificSearch';

export const getContainerName = (): string | null => {
    return getFromLocalStorage(SEARCH_CONTAINER);
};

export const getRandomUserId = (): string => {
    return getFromLocalStorageOrDefault(RANDOM_USER_ID_KEY);
};

export const getShowDetails = (): boolean => {
    const show = getFromLocalStorage(SHOW_DETAILS);
    return JSON.parse(show ? show : 'false');
};

export const getShowValidation = (): boolean => {
    const show = getFromLocalStorage(SHOW_VALIDATION);
    return JSON.parse(show ? show : 'false');
};

export const getShowFieldSpecificSearch = (): boolean => {
    const show = getFromLocalStorage(SHOW_FIELD_SPECIFIC_SEARCH);
    return JSON.parse(show ? show : 'false');
};

export const setContainerName = (containerName: string): void => {
    storeToLocalStorage(SEARCH_CONTAINER, containerName);
};

export const setUserId = (userId: string): void => {
    storeToLocalStorage(RANDOM_USER_ID_KEY, userId);
};

export const setShowDetails = (showDetails: boolean): void => {
    storeToLocalStorage(SHOW_DETAILS, JSON.stringify(showDetails));
};

export const setShowValidation = (showValidation: boolean): void => {
    storeToLocalStorage(SHOW_VALIDATION, JSON.stringify(showValidation));
};

export const setShowFieldSpecificSearch = (showFieldSpecificSearch: boolean): void => {
    storeToLocalStorage(SHOW_FIELD_SPECIFIC_SEARCH, JSON.stringify(showFieldSpecificSearch));
};

